// In Vite, we need to use import.meta.env instead of process.env

const apiUrl =
  import.meta.env.VITE_API_URL || "https://app.reachthepeople.ai/api";

export { apiUrl };
